import React from "react";
import {Stack } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

function FinalSummary({data }) {

    console.log("final wfwefwrf", data)
    const columns = [
        {
            field: "category",
            headerName: "Category",
            align: "center",
            headerAlign: "center",
            flex: 1,
        },
        {
            field: "brand",
            headerName: "Brand",
            align: "center",
            headerAlign: "center",
            flex: 1,
        },
        {
            field: "option",
            headerName: "Option",
            align: "center",
            headerAlign: "center",
            flex: 1,
        },
        {
            field: "count",
            headerName: "Count",
            align: "center",
            headerAlign: "center",
            flex: 1,
        },
        {
            field: "discount",
            headerName: "Discount(%)",
            align: "center",
            headerAlign: "center",
            flex: 1,
        },
        {
            field: "exclusionCount",
            headerName: "Exclusion count",
            align: "center",
            headerAlign: "center",
            flex: 1,
        },
        {
            field: "scheme",
            headerName: "Scheme",
            align: "center",
            headerAlign: "center",
            flex: 1,
        },
        {
            field: "date",
            headerName: "Date Range",
            align: "center",
            headerAlign: "center",
            flex: 1,
        },
        {
            field: "days",
            headerName: "Days",
            align: "center",
            headerAlign: "center",
            flex: 1,
        },
    ];

    const rowsWithId = data.map((row, index) => ({
  id: index, // or index + 1
  ...row,
}));

    return (
        <Stack width="98%" p={"1, 2"} maxHeight={400}>
             <DataGrid
                rows={rowsWithId}
                columns={columns}
                disableColumnMenu
                hideFooter
                // processRowUpdate={handleRowUpdate}
                experimentalFeatures={{ newEditingApi: true }}
                maxHeight={'100%'}
                // loading={rowsWithId.length === 0}
            />
        </Stack>
    );
}

export default FinalSummary;
